/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateCartRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {UpdateCartResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const updateCart = (request:UpdateCartRequest, options?: CashRequestOptions) => post<UpdateCartRequest, UpdateCartResponse>("/cash-app/local/cart/update", request, {...options, rejectOnError: true })